import(/* webpackMode: "eager" */ "/home/allison/git/monorepo/frontend/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"]}],\"variableName\":\"inter\"}");
;
import(/* webpackMode: "eager", webpackExports: ["LayoutWrapper"] */ "/home/allison/git/monorepo/frontend/src/components/LayoutWrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ComposeProvider"] */ "/home/allison/git/monorepo/frontend/src/context/ComposeContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["OmniBoxProvider"] */ "/home/allison/git/monorepo/frontend/src/context/OmniBoxContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["UserInfoProvider"] */ "/home/allison/git/monorepo/frontend/src/context/UserInfoContext.tsx");
;
import(/* webpackMode: "eager" */ "/home/allison/git/monorepo/frontend/src/styles/globals.css");
;
import(/* webpackMode: "eager" */ "/home/allison/git/monorepo/frontend/src/styles/logo.css");
;
import(/* webpackMode: "eager", webpackExports: ["ThemeProvider"] */ "/home/allison/git/monorepo/frontend/src/theme/ThemeContext.tsx");
